import angular from 'angular';

angular.module('cloudX').filter('isActive', [isActiveFilter]);

function isActiveFilter() {
  return function(array, current) {
    if (!angular.isArray(array)) {
      return array;
    }
    return array.filter(item => {
      if (item.isActive) return true;
      if (typeof current === 'undefined') return false;
      if (current === null) return false;
      if (typeof current === 'object') {
        if (angular.equals(current, item)) return true;
        if (typeof item.id !== 'undefined' && current.id === item.id) return true;
        return false;
      }
      if (typeof current !== 'string') return false;
      if (typeof item.id !== 'undefined' && item.id === current) return true;

      return false;
    });
  };
}
